// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file mono/projectdata/v1/proposal_pricing_v2.proto (package mono.projectdata.v1, syntax proto3)
/* eslint-disable */ // @ts-nocheck
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { PricingAdjustmentView, PricingLink, PricingRateBookRow } from "./proposal_pricing_ratebook_pb";
import { ProposalBlackHatRange } from "./proposal_home_pb";
import { PricingWorkbook } from "../../datagateway/v1/proposal_pricing_pb";
/**
 * PRP-11 (SAD-1128): "Refresh from Section B". Rebinds the project's pricing
 * scenarios to the current Section B LCATs and CLINs without touching a rate a
 * person set, then refreshes the LCAT -> registry links. Writer gate.
 *
 * @generated from message mono.projectdata.v1.RefreshPricingFromSolicitationRequest
 */ export class RefreshPricingFromSolicitationRequest extends Message {
    static fromBinary(bytes, options) {
        return new RefreshPricingFromSolicitationRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RefreshPricingFromSolicitationRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RefreshPricingFromSolicitationRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RefreshPricingFromSolicitationRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * "" = every scenario of the project
   *
   * @generated from field: string scenario_id = 2;
   */ _define_property(this, "scenarioId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(RefreshPricingFromSolicitationRequest, "runtime", proto3);
_define_property(RefreshPricingFromSolicitationRequest, "typeName", "mono.projectdata.v1.RefreshPricingFromSolicitationRequest");
_define_property(RefreshPricingFromSolicitationRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.RefreshPricingFromSolicitationResponse
 */ export class RefreshPricingFromSolicitationResponse extends Message {
    static fromBinary(bytes, options) {
        return new RefreshPricingFromSolicitationResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new RefreshPricingFromSolicitationResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new RefreshPricingFromSolicitationResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(RefreshPricingFromSolicitationResponse, a, b);
    }
    constructor(data){
        super(), /**
   * categories appended for new Section B LCATs
   *
   * @generated from field: int32 added = 1;
   */ _define_property(this, "added", 0), /**
   * categories newly marked removedFromSectionB
   *
   * @generated from field: int32 removed = 2;
   */ _define_property(this, "removed", 0), /**
   * categories whose title followed Section B
   *
   * @generated from field: int32 retitled = 3;
   */ _define_property(this, "retitled", 0), /**
   * lcat_registry_links rows written by the matcher
   *
   * @generated from field: int32 links_matched = 4;
   */ _define_property(this, "linksMatched", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(RefreshPricingFromSolicitationResponse, "runtime", proto3);
_define_property(RefreshPricingFromSolicitationResponse, "typeName", "mono.projectdata.v1.RefreshPricingFromSolicitationResponse");
_define_property(RefreshPricingFromSolicitationResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "added",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 2,
            name: "removed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "retitled",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "links_matched",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetPricingRateRequest
 */ export class SetPricingRateRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetPricingRateRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPricingRateRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPricingRateRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPricingRateRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 2;
   */ _define_property(this, "scenarioId", ""), /**
   * @generated from field: string category_id = 3;
   */ _define_property(this, "categoryId", ""), /**
   * @generated from field: string period_key = 4;
   */ _define_property(this, "periodKey", ""), /**
   * suggestion | observation | manual | clear
   *
   * @generated from field: string basis = 5;
   */ _define_property(this, "basis", ""), /**
   * basis = suggestion (RateBookSuggestion.token)
   *
   * @generated from field: string suggestion_token = 6;
   */ _define_property(this, "suggestionToken", ""), /**
   * basis = observation
   *
   * @generated from field: string observation_id = 7;
   */ _define_property(this, "observationId", ""), /**
   * @generated from field: int32 observation_version = 8;
   */ _define_property(this, "observationVersion", 0), /**
   * manual (required); observation (optional override)
   *
   * @generated from field: string amount = 9;
   */ _define_property(this, "amount", ""), /**
   * required when Using differs from Suggested (S6)
   *
   * @generated from field: string reason = 10;
   */ _define_property(this, "reason", ""), /**
   * GetPricingRateBookResponse.scenario_updated_at
   *
   * @generated from field: string expected_updated_at = 11;
   */ _define_property(this, "expectedUpdatedAt", ""), /**
   * basis = adjusted_suggestion; must match the winning entry
   *
   * @generated from field: string adjustment_id = 12;
   */ _define_property(this, "adjustmentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPricingRateRequest, "runtime", proto3);
_define_property(SetPricingRateRequest, "typeName", "mono.projectdata.v1.SetPricingRateRequest");
_define_property(SetPricingRateRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "category_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "basis",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "suggestion_token",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "observation_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "observation_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 9,
            name: "amount",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 11,
            name: "expected_updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 12,
            name: "adjustment_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetPricingRateResponse
 */ export class SetPricingRateResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetPricingRateResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPricingRateResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPricingRateResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPricingRateResponse, a, b);
    }
    constructor(data){
        super(), /**
   * absent only when post-commit recomposition failed
   *
   * @generated from field: mono.projectdata.v1.PricingTotals totals = 3;
   */ _define_property(this, "totals", void 0), /**
   * @generated from field: mono.projectdata.v1.PricingRateBookRow row = 1;
   */ _define_property(this, "row", void 0), /**
   * @generated from field: string scenario_updated_at = 2;
   */ _define_property(this, "scenarioUpdatedAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPricingRateResponse, "runtime", proto3);
_define_property(SetPricingRateResponse, "typeName", "mono.projectdata.v1.SetPricingRateResponse");
_define_property(SetPricingRateResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 3,
            name: "totals",
            kind: "message",
            T: PricingTotals
        },
        {
            no: 1,
            name: "row",
            kind: "message",
            T: PricingRateBookRow
        },
        {
            no: 2,
            name: "scenario_updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PricingPatchOp
 */ export class PricingPatchOp extends Message {
    static fromBinary(bytes, options) {
        return new PricingPatchOp().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingPatchOp().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingPatchOp().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingPatchOp, a, b);
    }
    constructor(data){
        super(), /**
   * set | remove
   *
   * @generated from field: string op = 1;
   */ _define_property(this, "op", ""), /**
   * allow-listed JSON pointer
   *
   * @generated from field: string path = 2;
   */ _define_property(this, "path", ""), /**
   * set only
   *
   * @generated from field: string value_json = 3;
   */ _define_property(this, "valueJson", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingPatchOp, "runtime", proto3);
_define_property(PricingPatchOp, "typeName", "mono.projectdata.v1.PricingPatchOp");
_define_property(PricingPatchOp, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "op",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "path",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "value_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PatchPricingScenarioRequest
 */ export class PatchPricingScenarioRequest extends Message {
    static fromBinary(bytes, options) {
        return new PatchPricingScenarioRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PatchPricingScenarioRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PatchPricingScenarioRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PatchPricingScenarioRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 2;
   */ _define_property(this, "scenarioId", ""), /**
   * 1..50
   *
   * @generated from field: repeated mono.projectdata.v1.PricingPatchOp ops = 3;
   */ _define_property(this, "ops", []), /**
   * @generated from field: string expected_updated_at = 4;
   */ _define_property(this, "expectedUpdatedAt", ""), /**
   * idempotency: the last 50 are kept in globalConfig.patchBatches
   *
   * @generated from field: string client_batch_id = 5;
   */ _define_property(this, "clientBatchId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PatchPricingScenarioRequest, "runtime", proto3);
_define_property(PatchPricingScenarioRequest, "typeName", "mono.projectdata.v1.PatchPricingScenarioRequest");
_define_property(PatchPricingScenarioRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "ops",
            kind: "message",
            T: PricingPatchOp,
            repeated: true
        },
        {
            no: 4,
            name: "expected_updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "client_batch_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PatchPricingScenarioResponse
 */ export class PatchPricingScenarioResponse extends Message {
    static fromBinary(bytes, options) {
        return new PatchPricingScenarioResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PatchPricingScenarioResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PatchPricingScenarioResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PatchPricingScenarioResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PricingTotals totals = 3;
   */ _define_property(this, "totals", void 0), /**
   * @generated from field: string scenario_updated_at = 1;
   */ _define_property(this, "scenarioUpdatedAt", ""), /**
   * @generated from field: int32 applied = 2;
   */ _define_property(this, "applied", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PatchPricingScenarioResponse, "runtime", proto3);
_define_property(PatchPricingScenarioResponse, "typeName", "mono.projectdata.v1.PatchPricingScenarioResponse");
_define_property(PatchPricingScenarioResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 3,
            name: "totals",
            kind: "message",
            T: PricingTotals
        },
        {
            no: 1,
            name: "scenario_updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "applied",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DecideLcatRegistryLinkRequest
 */ export class DecideLcatRegistryLinkRequest extends Message {
    static fromBinary(bytes, options) {
        return new DecideLcatRegistryLinkRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideLcatRegistryLinkRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideLcatRegistryLinkRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideLcatRegistryLinkRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string lcat_logical_key = 2;
   */ _define_property(this, "lcatLogicalKey", ""), /**
   * price_from_source_vehicle | remap | as_written_only
   *
   * @generated from field: string decision = 3;
   */ _define_property(this, "decision", ""), /**
   * @generated from field: string source_vehicle_id = 4;
   */ _define_property(this, "sourceVehicleId", ""), /**
   * @generated from field: string entry_id = 5;
   */ _define_property(this, "entryId", ""), /**
   * @generated from field: int32 entry_version = 6;
   */ _define_property(this, "entryVersion", 0), /**
   * required
   *
   * @generated from field: string reason = 7;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideLcatRegistryLinkRequest, "runtime", proto3);
_define_property(DecideLcatRegistryLinkRequest, "typeName", "mono.projectdata.v1.DecideLcatRegistryLinkRequest");
_define_property(DecideLcatRegistryLinkRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "lcat_logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "decision",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "source_vehicle_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "entry_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "entry_version",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 7,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.DecideLcatRegistryLinkResponse
 */ export class DecideLcatRegistryLinkResponse extends Message {
    static fromBinary(bytes, options) {
        return new DecideLcatRegistryLinkResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new DecideLcatRegistryLinkResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new DecideLcatRegistryLinkResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(DecideLcatRegistryLinkResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PricingLink link = 1;
   */ _define_property(this, "link", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(DecideLcatRegistryLinkResponse, "runtime", proto3);
_define_property(DecideLcatRegistryLinkResponse, "typeName", "mono.projectdata.v1.DecideLcatRegistryLinkResponse");
_define_property(DecideLcatRegistryLinkResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "link",
            kind: "message",
            T: PricingLink
        }
    ]));
/**
 * PRP-14: aggregate money only, never person-level rates or observation rows.
 *
 * @generated from message mono.projectdata.v1.PricingTotals
 */ export class PricingTotals extends Message {
    static fromBinary(bytes, options) {
        return new PricingTotals().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingTotals().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingTotals().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingTotals, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int64 total_cents = 1;
   */ _define_property(this, "totalCents", protoInt64.zero), /**
   * @generated from field: int64 labor_cents = 2;
   */ _define_property(this, "laborCents", protoInt64.zero), /**
   * @generated from field: int64 non_labor_cents = 3;
   */ _define_property(this, "nonLaborCents", protoInt64.zero), /**
   * @generated from field: map<string, int64> by_period = 4;
   */ _define_property(this, "byPeriod", {}), /**
   * @generated from field: map<string, int64> labor_by_period = 5;
   */ _define_property(this, "laborByPeriod", {}), /**
   * @generated from field: map<string, int64> by_clin = 6;
   */ _define_property(this, "byClin", {}), /**
   * @generated from field: repeated string includes = 7;
   */ _define_property(this, "includes", []), /**
   * @generated from field: repeated string warnings = 8;
   */ _define_property(this, "warnings", []), /**
   * @generated from field: string calc_version = 9;
   */ _define_property(this, "calcVersion", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingTotals, "runtime", proto3);
_define_property(PricingTotals, "typeName", "mono.projectdata.v1.PricingTotals");
_define_property(PricingTotals, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 2,
            name: "labor_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "non_labor_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "by_period",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 3 /* ScalarType.INT64 */ 
            }
        },
        {
            no: 5,
            name: "labor_by_period",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 3 /* ScalarType.INT64 */ 
            }
        },
        {
            no: 6,
            name: "by_clin",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 3 /* ScalarType.INT64 */ 
            }
        },
        {
            no: 7,
            name: "includes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "calc_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ComputePricingTotalsRequest
 */ export class ComputePricingTotalsRequest extends Message {
    static fromBinary(bytes, options) {
        return new ComputePricingTotalsRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComputePricingTotalsRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComputePricingTotalsRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComputePricingTotalsRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 2;
   */ _define_property(this, "scenarioId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComputePricingTotalsRequest, "runtime", proto3);
_define_property(ComputePricingTotalsRequest, "typeName", "mono.projectdata.v1.ComputePricingTotalsRequest");
_define_property(ComputePricingTotalsRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ComputePricingTotalsResponse
 */ export class ComputePricingTotalsResponse extends Message {
    static fromBinary(bytes, options) {
        return new ComputePricingTotalsResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ComputePricingTotalsResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ComputePricingTotalsResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ComputePricingTotalsResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: int64 total_cents = 1;
   */ _define_property(this, "totalCents", protoInt64.zero), /**
   * @generated from field: int64 labor_cents = 2;
   */ _define_property(this, "laborCents", protoInt64.zero), /**
   * @generated from field: int64 non_labor_cents = 3;
   */ _define_property(this, "nonLaborCents", protoInt64.zero), /**
   * @generated from field: map<string, int64> by_period = 4;
   */ _define_property(this, "byPeriod", {}), /**
   * @generated from field: map<string, int64> labor_by_period = 5;
   */ _define_property(this, "laborByPeriod", {}), /**
   * @generated from field: map<string, int64> by_clin = 6;
   */ _define_property(this, "byClin", {}), /**
   * @generated from field: repeated string includes = 7;
   */ _define_property(this, "includes", []), /**
   * @generated from field: repeated string warnings = 8;
   */ _define_property(this, "warnings", []), /**
   * @generated from field: string calc_version = 9;
   */ _define_property(this, "calcVersion", ""), /**
   * @generated from field: repeated mono.projectdata.v1.ProposalBlackHatRange black_hat = 10;
   */ _define_property(this, "blackHat", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ComputePricingTotalsResponse, "runtime", proto3);
_define_property(ComputePricingTotalsResponse, "typeName", "mono.projectdata.v1.ComputePricingTotalsResponse");
_define_property(ComputePricingTotalsResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "total_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 2,
            name: "labor_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 3,
            name: "non_labor_cents",
            kind: "scalar",
            T: 3 /* ScalarType.INT64 */ 
        },
        {
            no: 4,
            name: "by_period",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 3 /* ScalarType.INT64 */ 
            }
        },
        {
            no: 5,
            name: "labor_by_period",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 3 /* ScalarType.INT64 */ 
            }
        },
        {
            no: 6,
            name: "by_clin",
            kind: "map",
            K: 9 /* ScalarType.STRING */ ,
            V: {
                kind: "scalar",
                T: 3 /* ScalarType.INT64 */ 
            }
        },
        {
            no: 7,
            name: "includes",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 8,
            name: "warnings",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 9,
            name: "calc_version",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 10,
            name: "black_hat",
            kind: "message",
            T: ProposalBlackHatRange,
            repeated: true
        }
    ]));
/**
 * PRP-26: switches the project's primary scenario; never a JSON patch.
 *
 * @generated from message mono.projectdata.v1.SetPrimaryPricingScenarioRequest
 */ export class SetPrimaryPricingScenarioRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetPrimaryPricingScenarioRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPrimaryPricingScenarioRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPrimaryPricingScenarioRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPrimaryPricingScenarioRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 2;
   */ _define_property(this, "scenarioId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPrimaryPricingScenarioRequest, "runtime", proto3);
_define_property(SetPrimaryPricingScenarioRequest, "typeName", "mono.projectdata.v1.SetPrimaryPricingScenarioRequest");
_define_property(SetPrimaryPricingScenarioRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetPrimaryPricingScenarioResponse
 */ export class SetPrimaryPricingScenarioResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetPrimaryPricingScenarioResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPrimaryPricingScenarioResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPrimaryPricingScenarioResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPrimaryPricingScenarioResponse, a, b);
    }
    constructor(data){
        super();
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPrimaryPricingScenarioResponse, "runtime", proto3);
_define_property(SetPrimaryPricingScenarioResponse, "typeName", "mono.projectdata.v1.SetPrimaryPricingScenarioResponse");
_define_property(SetPrimaryPricingScenarioResponse, "fields", proto3.util.newFieldList(()=>[]));
/**
 * PRP-33: team policy between pure Suggested and the person's Using choice.
 *
 * @generated from message mono.projectdata.v1.SetPricingAdjustmentRequest
 */ export class SetPricingAdjustmentRequest extends Message {
    static fromBinary(bytes, options) {
        return new SetPricingAdjustmentRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPricingAdjustmentRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPricingAdjustmentRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPricingAdjustmentRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 2;
   */ _define_property(this, "scenarioId", ""), /**
   * scenario | period | category | cell
   *
   * @generated from field: string scope = 3;
   */ _define_property(this, "scope", ""), /**
   * @generated from field: string period_key = 4;
   */ _define_property(this, "periodKey", ""), /**
   * @generated from field: string lcat_logical_key = 5;
   */ _define_property(this, "lcatLogicalKey", ""), /**
   * empty or zero clears
   *
   * @generated from field: string pct = 6;
   */ _define_property(this, "pct", ""), /**
   * required for set and clear
   *
   * @generated from field: string reason = 7;
   */ _define_property(this, "reason", ""), /**
   * @generated from field: bool reapply_to_using = 8;
   */ _define_property(this, "reapplyToUsing", false), /**
   * @generated from field: string expected_updated_at = 9;
   */ _define_property(this, "expectedUpdatedAt", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPricingAdjustmentRequest, "runtime", proto3);
_define_property(SetPricingAdjustmentRequest, "typeName", "mono.projectdata.v1.SetPricingAdjustmentRequest");
_define_property(SetPricingAdjustmentRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scope",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "lcat_logical_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "pct",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 7,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 8,
            name: "reapply_to_using",
            kind: "scalar",
            T: 8 /* ScalarType.BOOL */ 
        },
        {
            no: 9,
            name: "expected_updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.SetPricingAdjustmentResponse
 */ export class SetPricingAdjustmentResponse extends Message {
    static fromBinary(bytes, options) {
        return new SetPricingAdjustmentResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SetPricingAdjustmentResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SetPricingAdjustmentResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SetPricingAdjustmentResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string scenario_updated_at = 1;
   */ _define_property(this, "scenarioUpdatedAt", ""), /**
   * @generated from field: mono.projectdata.v1.PricingAdjustmentView adjustment = 2;
   */ _define_property(this, "adjustment", void 0), /**
   * @generated from field: int32 rows_governed = 3;
   */ _define_property(this, "rowsGoverned", 0), /**
   * @generated from field: int32 using_reapplied = 4;
   */ _define_property(this, "usingReapplied", 0), /**
   * @generated from field: int32 using_now_stale = 5;
   */ _define_property(this, "usingNowStale", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(SetPricingAdjustmentResponse, "runtime", proto3);
_define_property(SetPricingAdjustmentResponse, "typeName", "mono.projectdata.v1.SetPricingAdjustmentResponse");
_define_property(SetPricingAdjustmentResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scenario_updated_at",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "adjustment",
            kind: "message",
            T: PricingAdjustmentView
        },
        {
            no: 3,
            name: "rows_governed",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "using_reapplied",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 5,
            name: "using_now_stale",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        }
    ]));
/**
 * PRP-16: proposing a mapping reads the workbook; it never binds or writes it.
 *
 * @generated from message mono.projectdata.v1.ProposePricingWorkbookMappingRequest
 */ export class ProposePricingWorkbookMappingRequest extends Message {
    static fromBinary(bytes, options) {
        return new ProposePricingWorkbookMappingRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposePricingWorkbookMappingRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposePricingWorkbookMappingRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposePricingWorkbookMappingRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string scenario_id = 2;
   */ _define_property(this, "scenarioId", ""), /**
   * @generated from field: string volume_document_id = 3;
   */ _define_property(this, "volumeDocumentId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposePricingWorkbookMappingRequest, "runtime", proto3);
_define_property(ProposePricingWorkbookMappingRequest, "typeName", "mono.projectdata.v1.ProposePricingWorkbookMappingRequest");
_define_property(ProposePricingWorkbookMappingRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "scenario_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "volume_document_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PricingWorkbookMappingProposal
 */ export class PricingWorkbookMappingProposal extends Message {
    static fromBinary(bytes, options) {
        return new PricingWorkbookMappingProposal().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingWorkbookMappingProposal().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingWorkbookMappingProposal().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingWorkbookMappingProposal, a, b);
    }
    constructor(data){
        super(), /**
   * proposed | manual
   *
   * @generated from field: string status = 1;
   */ _define_property(this, "status", ""), /**
   * pricing-workbook-map/v1
   *
   * @generated from field: string mapping_json = 2;
   */ _define_property(this, "mappingJson", ""), /**
   * @generated from field: repeated string sheet_names = 3;
   */ _define_property(this, "sheetNames", []), /**
   * A1 refs on mapping.sheet, also persisted in mapping_json
   *
   * @generated from field: repeated string protected_cells = 4;
   */ _define_property(this, "protectedCells", []), /**
   * @generated from field: repeated string unmatched_periods = 5;
   */ _define_property(this, "unmatchedPeriods", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingWorkbookMappingProposal, "runtime", proto3);
_define_property(PricingWorkbookMappingProposal, "typeName", "mono.projectdata.v1.PricingWorkbookMappingProposal");
_define_property(PricingWorkbookMappingProposal, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "status",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "mapping_json",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sheet_names",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 4,
            name: "protected_cells",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        },
        {
            no: 5,
            name: "unmatched_periods",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.ProposePricingWorkbookMappingResponse
 */ export class ProposePricingWorkbookMappingResponse extends Message {
    static fromBinary(bytes, options) {
        return new ProposePricingWorkbookMappingResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ProposePricingWorkbookMappingResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ProposePricingWorkbookMappingResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ProposePricingWorkbookMappingResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.projectdata.v1.PricingWorkbookMappingProposal proposal = 1;
   */ _define_property(this, "proposal", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(ProposePricingWorkbookMappingResponse, "runtime", proto3);
_define_property(ProposePricingWorkbookMappingResponse, "typeName", "mono.projectdata.v1.ProposePricingWorkbookMappingResponse");
_define_property(ProposePricingWorkbookMappingResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "proposal",
            kind: "message",
            T: PricingWorkbookMappingProposal
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnbindPricingWorkbookRequest
 */ export class UnbindPricingWorkbookRequest extends Message {
    static fromBinary(bytes, options) {
        return new UnbindPricingWorkbookRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnbindPricingWorkbookRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnbindPricingWorkbookRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnbindPricingWorkbookRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string workbook_id = 2;
   */ _define_property(this, "workbookId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnbindPricingWorkbookRequest, "runtime", proto3);
_define_property(UnbindPricingWorkbookRequest, "typeName", "mono.projectdata.v1.UnbindPricingWorkbookRequest");
_define_property(UnbindPricingWorkbookRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workbook_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.UnbindPricingWorkbookResponse
 */ export class UnbindPricingWorkbookResponse extends Message {
    static fromBinary(bytes, options) {
        return new UnbindPricingWorkbookResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new UnbindPricingWorkbookResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new UnbindPricingWorkbookResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(UnbindPricingWorkbookResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: mono.datagateway.v1.PricingWorkbook workbook = 1;
   */ _define_property(this, "workbook", void 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(UnbindPricingWorkbookResponse, "runtime", proto3);
_define_property(UnbindPricingWorkbookResponse, "typeName", "mono.projectdata.v1.UnbindPricingWorkbookResponse");
_define_property(UnbindPricingWorkbookResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "workbook",
            kind: "message",
            T: PricingWorkbook
        }
    ]));
/**
 * An empty version freezes the scenario now. Use the returned version ID for
 * confirmation and retries. Empty period_keys selects all mapped periods.
 *
 * @generated from message mono.projectdata.v1.FillPricingWorkbookRequest
 */ export class FillPricingWorkbookRequest extends Message {
    static fromBinary(bytes, options) {
        return new FillPricingWorkbookRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FillPricingWorkbookRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FillPricingWorkbookRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FillPricingWorkbookRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string workbook_id = 2;
   */ _define_property(this, "workbookId", ""), /**
   * @generated from field: string scenario_version_id = 3;
   */ _define_property(this, "scenarioVersionId", ""), /**
   * @generated from field: repeated string period_keys = 4;
   */ _define_property(this, "periodKeys", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(FillPricingWorkbookRequest, "runtime", proto3);
_define_property(FillPricingWorkbookRequest, "typeName", "mono.projectdata.v1.FillPricingWorkbookRequest");
_define_property(FillPricingWorkbookRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workbook_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scenario_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PreviewPricingWorkbookFillRequest
 */ export class PreviewPricingWorkbookFillRequest extends Message {
    static fromBinary(bytes, options) {
        return new PreviewPricingWorkbookFillRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewPricingWorkbookFillRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewPricingWorkbookFillRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewPricingWorkbookFillRequest, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string project_id = 1;
   */ _define_property(this, "projectId", ""), /**
   * @generated from field: string workbook_id = 2;
   */ _define_property(this, "workbookId", ""), /**
   * @generated from field: string scenario_version_id = 3;
   */ _define_property(this, "scenarioVersionId", ""), /**
   * @generated from field: repeated string period_keys = 4;
   */ _define_property(this, "periodKeys", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewPricingWorkbookFillRequest, "runtime", proto3);
_define_property(PreviewPricingWorkbookFillRequest, "typeName", "mono.projectdata.v1.PreviewPricingWorkbookFillRequest");
_define_property(PreviewPricingWorkbookFillRequest, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "project_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "workbook_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "scenario_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "period_keys",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ ,
            repeated: true
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PricingWorkbookFillSkip
 */ export class PricingWorkbookFillSkip extends Message {
    static fromBinary(bytes, options) {
        return new PricingWorkbookFillSkip().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingWorkbookFillSkip().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingWorkbookFillSkip().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingWorkbookFillSkip, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string category_id = 1;
   */ _define_property(this, "categoryId", ""), /**
   * @generated from field: string period_key = 2;
   */ _define_property(this, "periodKey", ""), /**
   * @generated from field: string reason = 3;
   */ _define_property(this, "reason", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingWorkbookFillSkip, "runtime", proto3);
_define_property(PricingWorkbookFillSkip, "typeName", "mono.projectdata.v1.PricingWorkbookFillSkip");
_define_property(PricingWorkbookFillSkip, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "category_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "reason",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PricingWorkbookFillCell
 */ export class PricingWorkbookFillCell extends Message {
    static fromBinary(bytes, options) {
        return new PricingWorkbookFillCell().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PricingWorkbookFillCell().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PricingWorkbookFillCell().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PricingWorkbookFillCell, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string category_id = 1;
   */ _define_property(this, "categoryId", ""), /**
   * @generated from field: string period_key = 2;
   */ _define_property(this, "periodKey", ""), /**
   * @generated from field: string sheet = 3;
   */ _define_property(this, "sheet", ""), /**
   * @generated from field: string cell = 4;
   */ _define_property(this, "cell", ""), /**
   * @generated from field: string current_value = 5;
   */ _define_property(this, "currentValue", ""), /**
   * @generated from field: double new_value = 6;
   */ _define_property(this, "newValue", 0);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PricingWorkbookFillCell, "runtime", proto3);
_define_property(PricingWorkbookFillCell, "typeName", "mono.projectdata.v1.PricingWorkbookFillCell");
_define_property(PricingWorkbookFillCell, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "category_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "period_key",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 3,
            name: "sheet",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 4,
            name: "cell",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 5,
            name: "current_value",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 6,
            name: "new_value",
            kind: "scalar",
            T: 1 /* ScalarType.DOUBLE */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.FillPricingWorkbookResponse
 */ export class FillPricingWorkbookResponse extends Message {
    static fromBinary(bytes, options) {
        return new FillPricingWorkbookResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new FillPricingWorkbookResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new FillPricingWorkbookResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(FillPricingWorkbookResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string document_version_id = 1;
   */ _define_property(this, "documentVersionId", ""), /**
   * @generated from field: int32 cells_written = 2;
   */ _define_property(this, "cellsWritten", 0), /**
   * @generated from field: int32 rows_written = 3;
   */ _define_property(this, "rowsWritten", 0), /**
   * @generated from field: repeated mono.projectdata.v1.PricingWorkbookFillSkip skipped = 4;
   */ _define_property(this, "skipped", []), /**
   * @generated from field: string scenario_version_id = 5;
   */ _define_property(this, "scenarioVersionId", "");
        proto3.util.initPartial(data, this);
    }
}
_define_property(FillPricingWorkbookResponse, "runtime", proto3);
_define_property(FillPricingWorkbookResponse, "typeName", "mono.projectdata.v1.FillPricingWorkbookResponse");
_define_property(FillPricingWorkbookResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "document_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "cells_written",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 3,
            name: "rows_written",
            kind: "scalar",
            T: 5 /* ScalarType.INT32 */ 
        },
        {
            no: 4,
            name: "skipped",
            kind: "message",
            T: PricingWorkbookFillSkip,
            repeated: true
        },
        {
            no: 5,
            name: "scenario_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        }
    ]));
/**
 * @generated from message mono.projectdata.v1.PreviewPricingWorkbookFillResponse
 */ export class PreviewPricingWorkbookFillResponse extends Message {
    static fromBinary(bytes, options) {
        return new PreviewPricingWorkbookFillResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PreviewPricingWorkbookFillResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PreviewPricingWorkbookFillResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PreviewPricingWorkbookFillResponse, a, b);
    }
    constructor(data){
        super(), /**
   * @generated from field: string scenario_version_id = 1;
   */ _define_property(this, "scenarioVersionId", ""), /**
   * @generated from field: repeated mono.projectdata.v1.PricingWorkbookFillCell changed_cells = 2;
   */ _define_property(this, "changedCells", []), /**
   * @generated from field: repeated mono.projectdata.v1.PricingWorkbookFillSkip skipped = 3;
   */ _define_property(this, "skipped", []);
        proto3.util.initPartial(data, this);
    }
}
_define_property(PreviewPricingWorkbookFillResponse, "runtime", proto3);
_define_property(PreviewPricingWorkbookFillResponse, "typeName", "mono.projectdata.v1.PreviewPricingWorkbookFillResponse");
_define_property(PreviewPricingWorkbookFillResponse, "fields", proto3.util.newFieldList(()=>[
        {
            no: 1,
            name: "scenario_version_id",
            kind: "scalar",
            T: 9 /* ScalarType.STRING */ 
        },
        {
            no: 2,
            name: "changed_cells",
            kind: "message",
            T: PricingWorkbookFillCell,
            repeated: true
        },
        {
            no: 3,
            name: "skipped",
            kind: "message",
            T: PricingWorkbookFillSkip,
            repeated: true
        }
    ]));
